import { User } from '@/types';

export interface PlayerStats {
  steamid64: string;
  team: string;
  roundsPlayed: number;
  name: string;
  kills: number;
  deaths: number;
  assists: number;
  '3k': number;
  '4k': number;
  '5k': number;
  utilityDamage: number;
  firstkillT: number;
  firstkillCt: number;
  firstdeathT: number;
  firstdeathCt: number;
  entry_wins: number;
  entry_count: number;
  flashbang_assists: number;
  flash_count: number;
  mvp: number;
  killsPerRound: string;
  killDeathRatio: string;
  entries: number;
  entrySuccessRate: number;
  user: User;
  headshots: number;
}

export enum MatchStatus {
  UPCOMING = 'upcoming',
  SERVER_LIVE = 'server_live',
  LIVE = 'live',
  ENDED = 'ended',
}

export interface LeaguePlayer {
  id: number;
  user: User;
}

export interface PlayerData {
  team1: LeaguePlayer[];
  team2: LeaguePlayer[];
}
export interface MapStats {
  team1: PlayerStats[];
  team2: PlayerStats[];
}
